export default "__VITE_ASSET__CBfNWXnW__"